import React, { useEffect, useState, useRef } from 'react';
import { GMap } from 'primereact/gmap';
import { loadGoogleMapsEmpleado } from '../DatosEmpleado/GoogleMapsEmpleado';

export const ICONOS_SINIESTRO = {
    EXPLOSION: 'M22.61,15.22L20.45,16.58L22,19.25L19.34,20L19.46,23.11L16.42,22.25L14.73,24.81L12.43,22.8L9.67,24.45L8.74,21.5L5.7,21.84L5.59,18.73L2.91,17.44L4.93,15L3.1,12.56L5.68,10.66L4.29,7.91L7.26,7.56L6.92,4.53L9.84,5.43L11.5,3L13.79,4.96L16.5,3.25L17.43,6.17L20.47,5.85L20.59,8.96L23.27,10.27L21.26,12.7L22.61,15.22Z',
    ALERTA: 'M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16',
    ROBO: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
    CASITA: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
    TORRE: 'M21 21H3v-2h2v-4h2v4h10v-4h2v4h2v2zM10 5h4v2h-4V5zm-1 2h6v2H9V7zm-1 2h8v2H8V9zm-1 2h10v2H7v-2zm-1 2h12v2H6v-2z',
    VIGIA: 'M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z',
    INCENDIO: 'M11.5,2C11.5,2 7.5,6 7.5,11.5C7.5,13.98 9.5,15.98 11.98,15.98C14.46,15.98 16.48,13.98 16.48,11.5C16.48,9.98 15.48,8.48 14.98,7.48L11.5,2M11.98,13.98C11.15,13.98 10.48,13.31 10.48,12.48C10.48,11.65 11.15,10.98 11.98,10.98C12.81,10.98 13.48,11.65 13.48,12.48C13.48,13.31 12.81,13.98 11.98,13.98Z',
    CANDADO: 'M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 5a3 3 0 1 1 6 0v3H9V7zm3 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
    MUERTE: 'M12,2C8.13,2 5,5.13 5,9V14C5,15.66 6.34,17 8,17H9V19C9,20.1 9.9,21 11,21H13C14.1,21 15,20.1 15,19V17H16C17.66,17 19,15.66 19,14V9C19,5.13 15.87,2 12,2M8.5,10.5C7.67,10.5 7,9.83 7,9C7,8.17 7.67,7.5 8.5,7.5C9.33,7.5 10,8.17 10,9C10,9.83 9.33,10.5 8.5,10.5M11,15H13V17H11V15M15.5,10.5C14.67,10.5 14,9.83 14,9C14,8.17 14.67,7.5 15.5,7.5C16.33,7.5 17,8.17 17,9C17,9.83 16.33,10.5 15.5,10.5Z',
    ARMA: 'M15.4 3L16.4 5H21V8H18.8L18.4 11H20.6L19 19C18.6 21 17 21 17 21H14C14 21 14 20 13 18C12 16 12 15 12 15L11 15C11 15 9.4 15.6 9 16C8.6 16.4 6 16.2 6 16.2L6 14.8C6 14.8 7 14.2 8 14C9 13.8 10 13 10 13V12L5 12C3.8 12 3 11.2 3 10V4.5C3 3.5 3.5 3 4.5 3H15.4ZM13.8 5H4.5V10H13.8V5Z',
    ACCIDENTE: 'M19,10 L17.5,5.5 C17.2,4.6 16.3,4 15.3,4 L8.7,4 C7.7,4 6.8,4.6 6.5,5.5 L5,10 C4.4,10 4,10.4 4,11 L4,18 C4,18.5 4.5,19 5,19 L6,19 C6.5,19 7,18.5 7,18 L7,17 L17,17 L17,18 C17,18.5 17.5,19 18,19 L19,19 C19.5,19 20,18.5 20,18 L20,11 C20,10.4 19.6,10 19,10 Z M6.8,6.8 C7,6.3 7.5,6 8.1,6 L15.9,6 C16.5,6 17,6.3 17.2,6.8 L18.3,10 L5.7,10 L6.8,6.8 Z M7.5,15 C6.7,15 6,14.3 6,13.5 C6,12.7 6.7,12 7.5,12 C8.3,12 9,12.7 9,13.5 C9,14.3 8.3,15 7.5,15 Z M16.5,15 C15.7,15 15,14.3 15,13.5 C15,12.7 15.7,12 16.5,12 C17.3,12 18,12.7 18,13.5 C18,14.3 17.3,15 16.5,15 Z'
};

export const obtenerEstiloFallback = (nombreTipo = '') => {
    const nombre = typeof nombreTipo === 'string' ? nombreTipo.toUpperCase() : '';
    if (nombre.includes('SICARIATO') || nombre.includes('MUERTE') || nombre.includes('HOMICIDIO')) {
        return { icono: ICONOS_SINIESTRO.MUERTE, color: '#212121' }; // Negro profundo
    }
    if (nombre.includes('ROBO') || nombre.includes('HURTO') || nombre.includes('ASALTO')) {
        return { icono: ICONOS_SINIESTRO.ROBO, color: '#fb8c00' }; // Naranja distintivo
    }
    if (nombre.includes('ARMADO') || nombre.includes('BALACERA') || nombre.includes('TIROTEO')) {
        return { icono: ICONOS_SINIESTRO.ARMA, color: '#d81b60' }; // Arma de fuego fucsia/rojo oscuro
    }
    if (nombre.includes('EXPLOSION') || nombre.includes('ATENTADO')) {
        return { icono: ICONOS_SINIESTRO.EXPLOSION, color: '#d81b60' }; // Fucsia/Rosa fuerte
    }
    if (nombre.includes('INCENDIO') || nombre.includes('FUEGO')) {
        return { icono: ICONOS_SINIESTRO.INCENDIO, color: '#d32f2f' }; // Rojo Fuego
    }
    if (nombre.includes('ACCIDENTE') || nombre.includes('CHOQUE') || nombre.includes('TRANSITO')) {
        return { icono: ICONOS_SINIESTRO.ALERTA, color: '#fbc02d' }; // Amarillo Precaución
    }
    if (nombre.includes('SOSPECHOSO') || nombre.includes('INCURSION')) {
        return { icono: ICONOS_SINIESTRO.VIGIA, color: '#7b1fa2' }; // Morado
    }
    return { icono: ICONOS_SINIESTRO.ALERTA, color: '#e53935' }; // Rojo default
};

const crearUrlPinSVG = (pathIcono, color) => {
    // Escala del pin
    const pinColor = color || '#e53935';
    // Si la ruta del SVG no viene, usamos una por defecto (Alerta)
    const iconPath = pathIcono || 'M12 2L1 21h22L12 2zm0 3.45l8.27 14.3H3.73L12 5.45zM11 16h2v2h-2v-2zm0-7h2v5h-2V9z';
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="0 0 24 32">
            <!-- Sombra -->
            <ellipse cx="12" cy="30" rx="6" ry="2" fill="rgba(0,0,0,0.3)"/>
            <!-- Globo del Pin -->
            <path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 18 12 18s12-9 12-18c0-6.627-5.373-12-12-12z" fill="${pinColor}" stroke="#FFFFFF" stroke-width="1.5"/>
            <!-- Contenedor interno e icono -->
            <g transform="translate(4.5, 4.5) scale(0.625)">
                <path d="${iconPath}" fill="#FFFFFF"/>
            </g>
        </svg>
    `;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg.trim())}`;
};

const ESTILO_MAPA_LIMPIO = [
    {
        featureType: 'poi', // Puntos de interés (escuelas, hospitales, etc.)
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }] // Ocultar iconos
    },
    {
        featureType: 'transit', // Estaciones de bus, metro, etc.
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }]
    }
];

const UbicacionVisor = ({ listaDePuntos = [], listaDeRutas = [], listaDeAreas = [], hoveredPuntoId, selectedPuntoId }) => {
    //console.log('DATOS PUNTOS..: ', listaDePuntos);
    const [mapReady, setMapReady] = useState(false);
    const mapContainerRef = useRef(null); 
    const mapRef = useRef(null); 
    const prevDatosRef = useRef('');
    const markersRef = useRef(new Map());
    const overlaysRef = useRef([]);
    const infoWindowRef = useRef(null);

    // --- PARSEADOR DE RUTAS (LINESTRING) ---
    const parsearRutaWKT = (wkt, color = '#334eff', nombre = '') => {
        try {
            const contenido = wkt.match(/\(([^)]+)\)/)[1];
            const coordenadas = contenido.split(',').map((par) => {
                const [lat, lng] = par.trim().split(' ');
                return { lat: parseFloat(lat), lng: parseFloat(lng) };
            });
            const polyline = new window.google.maps.Polyline({
                path: coordenadas,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 6
            });

            polyline.addListener('click', (event) => {
                if (mapRef.current) {
                    const infoWindow = new window.google.maps.InfoWindow({
                        content: `<div style="font-family: 'Inter', sans-serif; width: 240px; padding: 16px; border-radius: 12px; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid ${color}">
                                    <div style="margin-bottom: 6px;">
                                        <span style="background: #e3f2fd; color: #1565c0; padding: 3px 8px; border-radius: 4px; font-weight: 700; font-size: 10px; letter-spacing: 0.5px; text-transform: uppercase;">
                                            <i class="pi pi-directions" style="font-size: 10px; margin-right: 4px;"></i> RUTA ASIGNADA
                                        </span>
                                    </div>
                                    <h3 style="margin: 0 0 5px 0; color: #1e293b; font-size: 15px; font-weight: 600;">${nombre || 'Ruta'}</h3>
                                    <p style="margin: 0; color: #64748b; font-size: 13px; line-height: 1.4;">Ruta operativa asignada.</p>
                                  </div>`,
                        position: event.latLng
                    });
                    infoWindow.open(mapRef.current);
                }
            });

            return polyline;
        } catch (e) {
            return null;
        }
    };

    const obtenerCentroPoligono = (paths) => {
        let bounds = new window.google.maps.LatLngBounds();
        paths.forEach((coord) => bounds.extend(coord));
        return bounds.getCenter();
    };

    // --- NUEVO: PARSEADOR DE ÁREAS (POLYGON) ---
    const parsearAreaWKT = (wkt, color = '#FF0000', nombre = 'Área', descripcion = '') => {
        try {
            const match = wkt.match(/\(+([^)]+)\)+/);
            if (!match) return null;
            const coordenadas = match[1].split(',').map((par) => {
                const [lat, lng] = par.trim().split(/\s+/);
                return { lat: parseFloat(lat), lng: parseFloat(lng) };
            });

            const polygon = new window.google.maps.Polygon({
                paths: coordenadas,
                strokeColor: color,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.35,
                clickable: true
            });

            // Agregamos el listener, pero buscaremos la instancia del mapa al momento del CLICK
            polygon.addListener('click', (event) => {
                if (mapRef.current) {
                    const infoWindow = new window.google.maps.InfoWindow({
                        content: `<div style="font-family: 'Inter', sans-serif; width: 260px; padding: 16px; border-radius: 12px; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid ${color || '#4caf50'}">
                                    <div style="margin-bottom: 6px;">
                                        <span style="background: #e8f5e9; color: #2e7d32; padding: 3px 8px; border-radius: 4px; font-weight: 700; font-size: 10px; letter-spacing: 0.5px; text-transform: uppercase;">
                                            <i class="pi pi-clone" style="font-size: 10px; margin-right: 4px;"></i> ZONA BASE
                                        </span>
                                    </div>
                                    <h3 style="margin: 0 0 5px 0; color: #1e293b; font-size: 15px; font-weight: 600;">
                                        ${nombre || 'Zona Perimetral'}
                                    </h3>
                                    <p style="margin: 0; color: #64748b; font-size: 13px; line-height: 1.4;">
                                        ${descripcion || 'Área de guardia designada.'}
                                    </p>
                                  </div>`,
                        position: event.latLng
                    });
                    infoWindow.open(mapRef.current);
                } else {
                    console.warn('Instancia del mapa no lista aún');
                }
            });

            return polygon;
        } catch (e) {
            return null;
        }
    };

    useEffect(() => {
        const datosActuales = JSON.stringify({ listaDePuntos, listaDeRutas, listaDeAreas });
        if (prevDatosRef.current === datosActuales) return;
        prevDatosRef.current = datosActuales;

        loadGoogleMapsEmpleado(() => {
            if (!mapRef.current && mapContainerRef.current) {
                mapRef.current = new window.google.maps.Map(mapContainerRef.current, {
                    center: { lat: -0.180653, lng: -78.467834 },
                    zoom: 13,
                    styles: ESTILO_MAPA_LIMPIO,
                    mapTypeControl: true,
                    streetViewControl: false,
                    clickableIcons: false
                });
                setMapReady(true);
            }

            if (!infoWindowRef.current) {
                infoWindowRef.current = new window.google.maps.InfoWindow();
            }

            // Limpiar overlays anteriores
            overlaysRef.current.forEach(overlay => {
                if(overlay) overlay.setMap(null);
            });
            overlaysRef.current = [];
            markersRef.current.clear();

            const nuevosOverlays = [];

            // 1. Puntos
            listaDePuntos.forEach((p) => {
                let pinDataURL;
                if (p.tipo === 'puesto') {
                    pinDataURL = crearUrlPinSVG(ICONOS_SINIESTRO.CASITA, p.color || '#1e88e5'); // Tono azul / corporativo para puestos
                } else {
                    const fallback = obtenerEstiloFallback(p.tipoSin);
                    const iconoFinal = p.icono || fallback.icono;
                    
                    // Como el backend/front inyecta frecuentemente el mismo color (#f00707) a siniestros antiguos, forzamos variedad por nombre
                    let colorFinal = p.color;
                    if (!colorFinal || colorFinal.toLowerCase() === '#f00707' || colorFinal.toLowerCase() === '#ff0000') {
                        colorFinal = fallback.color;
                    }

                    pinDataURL = crearUrlPinSVG(iconoFinal, colorFinal); // Tono dinámico para siniestros
                }

                const marker = new window.google.maps.Marker({
                    position: { lat: p.lat, lng: p.lng },
                    title: p.nombre, // Este es el tooltip que sale al pasar el mouse
                    icon: {
                        url: pinDataURL,
                        scaledSize: new window.google.maps.Size(36, 48), // Tamaño ajustado al viewbox del SVG del globo
                        anchor: new window.google.maps.Point(18, 32) // Anclamos el pico inferior del globo
                    }
                });
                //console.log ('TIPO... : ', p.tipo)
                if (p.tipo === 'punto') {
                    marker.addListener('click', () => {
                        const currentMap = mapRef.current || marker.getMap();
                        if (currentMap) {
                            const isPropios = p.esPropio === 'Propio';
                            const badgeColor = isPropios ? '#e3f2fd' : '#fbe9e7';
                            const badgeText = isPropios ? '#1565c0' : '#d84315';
                            
                            let fuentesArr = [];
                            if (Array.isArray(p.fuentes)) {
                                fuentesArr = p.fuentes;
                            } else if (typeof p.fuentes === 'string' && p.fuentes.trim().startsWith('[')) {
                                try { fuentesArr = JSON.parse(p.fuentes); } catch(e) { console.error("Error parseando fuentes", e) }
                            }

                            const fuentesHtml =
                                fuentesArr && fuentesArr.length > 0
                                    ? fuentesArr
                                          .map(
                                              (f) => `
                <div style="margin-top: 8px; border: 1px solid #e0e0e0; border-radius: 6px; padding: 6px 10px; background: #fafafa;">
                    <a href="${f.link || f.url || '#'}" target="_blank" rel="noopener noreferrer" 
                       style="text-decoration: none; display: flex; align-items: center; gap: 8px;">
                        <span style="font-size: 16px; min-width: 18px;">🔗</span> 
                        <div style="display: flex; flex-direction: column;">
                           <strong style="color: #1a73e8; font-size: 13px;">${f.fuente || 'Fuente'}</strong>
                           <span style="color: #555; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 230px;">${f.descripcion || 'Ver enlace de referencia'}</span>
                        </div>
                    </a>
                </div>
            `
                                          )
                                          .join('')
                                    : '<div style="background: #f5f5f5; padding: 10px; border-radius: 6px; color: #777; font-size: 12px; text-align: center; margin-top: 5px;">Ninguna fuente registrada</div>';

                            infoWindowRef.current.setContent(`
            <div style="font-family: 'Inter', sans-serif; width: 320px; padding: 16px; border-radius: 12px; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-left: 5px solid ${p.color || '#e53935'}">
                <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 8px;">
                    <span style="background: ${badgeColor}; color: ${badgeText}; padding: 3px 8px; border-radius: 4px; font-weight: 700; font-size: 10px; letter-spacing: 0.5px; text-transform: uppercase;">
                        ${p.tipoSin}
                    </span>
                    <span style="color: #666; font-size: 11px; font-weight: 500; display: flex; align-items: center; gap: 4px;">
                        📅 ${p.fecha}
                    </span>
                </div>
                
                <h3 style="margin: 0 0 10px 0; color: #212121; font-size: 15px; font-weight: 600; line-height: 1.3;">
                    ${p.nombre || 'Sin descripción detallada'}
                </h3>
                
                <div style="margin-top: 15px; padding-top: 10px; border-top: 1px solid #f0f0f0;">
                    <strong style="font-size: 12px; color: #424242; display: block; margin-bottom: 8px;">
                        Evidencia y Enlaces (${fuentesArr ? fuentesArr.length : 0})
                    </strong>
                    <div style="max-height: 130px; overflow-y: auto; overflow-x: hidden; padding-right: 4px;">
                        ${fuentesHtml} 
                    </div>
                </div>
            </div>
        `);
                            infoWindowRef.current.open(currentMap, marker);
                        } else {
                            console.warn("No se encontró instancia del mapa al dar click", marker);
                        }
                    });
                } else {
                    marker.addListener('click', () => {
                        const currentMap = mapRef.current || marker.getMap();
                        if (currentMap) {
                            infoWindowRef.current.setContent(
                                `<div style="font-family: 'Inter', sans-serif; width: 280px; padding: 16px; border-radius: 12px; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-left: 5px solid ${p.color || '#1e88e5'}">
                                    <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 8px;">
                                        <span style="background: #e3f2fd; color: #1565c0; padding: 3px 8px; border-radius: 4px; font-weight: 700; font-size: 10px; letter-spacing: 0.5px; text-transform: uppercase;">
                                            <i class="pi pi-building" style="font-size: 10px; margin-right: 4px;"></i> PUESTO BASE
                                        </span>
                                    </div>
                                    <h3 style="margin: 0 0 5px 0; color: #1e293b; font-size: 16px; font-weight: 600; line-height: 1.3;">
                                        ${p.nombre || 'Puesto Sin Nombre'}
                                    </h3>
                                    <p style="margin: 0; color: #64748b; font-size: 13px; line-height: 1.4;">Base de control y seguimiento operativo.</p>
                                </div>`
                            );
                            infoWindowRef.current.open(currentMap, marker);
                        }
                    });
                }

                nuevosOverlays.push(marker);
                if (p.id) markersRef.current.set(p.id, marker);
            });

            // 2. Rutas
            listaDeRutas.forEach((r) => {
                const wkt = typeof r === 'string' ? r : r.wkt;
                const color = typeof r === 'string' ? undefined : r.color;
                const nombre = typeof r === 'string' ? '' : (r.nombre || '');
                const poly = parsearRutaWKT(wkt, color, nombre);
                if (poly) nuevosOverlays.push(poly);
            });

            // 3. Áreas
            listaDeAreas.forEach((a) => {
                const poly = parsearAreaWKT(a.wkt || a.area || a, a.color, a.nombre, a.descripcion);
                if (poly) nuevosOverlays.push(poly);
            });

            // Dibujar todo en el mapa nativo
            nuevosOverlays.forEach(overlay => overlay.setMap(mapRef.current));
            overlaysRef.current = nuevosOverlays;

            if (nuevosOverlays.length > 0) {
                const bounds = new window.google.maps.LatLngBounds();
                let hasValidBounds = false;

                nuevosOverlays.forEach(overlay => {
                    if (overlay instanceof window.google.maps.Marker) {
                         const pos = overlay.getPosition();
                         if (pos) { bounds.extend(pos); hasValidBounds = true; }
                    } else if (overlay.getPath && typeof overlay.getPath === 'function') {
                         const path = overlay.getPath();
                         path.forEach(latLng => bounds.extend(latLng));
                         hasValidBounds = true;
                    } else if (overlay.getPaths && typeof overlay.getPaths === 'function') {
                         const paths = overlay.getPaths();
                         paths.forEach(path => path.forEach(latLng => bounds.extend(latLng)));
                         hasValidBounds = true;
                    }
                });

                if (hasValidBounds) {
                    mapRef.current.fitBounds(bounds);
                    // Prevenir zoom excesivo si hay un solo elemento en pantalla
                    const listener = window.google.maps.event.addListener(mapRef.current, "idle", function() { 
                        if (mapRef.current.getZoom() > 16) mapRef.current.setZoom(16); 
                        window.google.maps.event.removeListener(listener); 
                    });
                }
            }
        });
    }, [listaDePuntos, listaDeRutas, listaDeAreas]);

    // EFECTO DE HOVER Y CLICK EN TABLA
    useEffect(() => {
        if (!mapReady) return;
        
        // Efecto Hover (Rebotar marcador)
        markersRef.current.forEach((marker, id) => {
            if (id === hoveredPuntoId) {
                marker.setAnimation(window.google.maps.Animation.BOUNCE);
            } else {
                marker.setAnimation(null);
            }
        });
        
    }, [hoveredPuntoId, mapReady]);

    useEffect(() => {
        if (!mapReady || !selectedPuntoId) return;
        const targetMarker = markersRef.current.get(selectedPuntoId);
        if (targetMarker && mapRef.current) {
            mapRef.current.panTo(targetMarker.getPosition());
            mapRef.current.setZoom(16);
            new window.google.maps.event.trigger(targetMarker, 'click');
        }
    }, [selectedPuntoId, mapReady]);

    return (
        <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
            <div className="surface-border border-2 border-round p-1 shadow-2" style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
                <div ref={mapContainerRef} style={{ position: 'relative', width: '100%', minHeight: '500px', maxHeight: '80vh', borderRadius: '6px', overflow: 'hidden' }} />
            </div>
        </div>
    );
};

export default UbicacionVisor;
